import React from "react";
import FormNewAdmin from "./FormNewAdmin";
import AdminList from "./AdminList";
import UserManagerCard from "./UserManagerCard";
import AdminMessageSettings from "./AdminMessageSettings";
import AdminBackupManager from "./AdminBackupManager";

const AdministrationPage = () => {
  return (
    <div className="container mx-auto px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8 text-center">
        <p className="text-sm font-bold uppercase text-sky-500 dark:text-sky-400">Administration</p>
        <h1 className="mt-3 text-3xl font-black text-slate-950 dark:text-white">Socle applicatif</h1>
      </header>

      <AdminMessageSettings />
      <AdminBackupManager />
      <FormNewAdmin />
      <AdminList />
      <UserManagerCard />
    </div>
  );
};

export default AdministrationPage;
